// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   CLIENT PORTAL - PROJECT DEPENDENCIES & DYNAMIC CREDENTIALS STYLES
   Matches Dashboard.css and Support.css precision SaaS theme
   ========================================================================== */

/* ── Hero Bar ──────────────────────────────────────────────────────────── */
.dep-hero-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;
}

.dep-hero-left {
    flex: 1 1;
    min-width: 260px;
}

.dep-hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px;
    background: #eef2ff;
    color: #4f46e5;
    border: 1px solid #c7d2fe;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 6px;
}

.dep-hero-badge .pulse-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #4f46e5;
    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.25);
}

.dep-hero-title {
    font-family: var(--font-heading, inherit);
    font-size: 22px;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 4px 0;
    letter-spacing: -0.4px;
}

.dep-hero-subtitle {
    font-size: 12.5px;
    color: #64748b;
    margin: 0;
    line-height: 1.45;
}

/* ── Executive KPI Cards Grid ──────────────────────────────────────────── */
.dep-kpi-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 16px;
}

@media (max-width: 992px) {
    .dep-kpi-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 576px) {
    .dep-kpi-grid {
        grid-template-columns: 1fr;
    }
}

.dep-kpi-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
    cursor: pointer;
    transition: all 0.2s ease;
}

.dep-kpi-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    border-color: #cbd5e1;
}

.dep-kpi-card.active {
    border-color: #4f46e5;
    background: #f8faff;
    box-shadow: 0 2px 8px rgba(79, 70, 229, 0.12);
}

.dep-kpi-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    flex-shrink: 0;
}

.dep-kpi-icon.pending {
    background: #fffbeb;
    color: #d97706;
}

.dep-kpi-icon.review {
    background: #eef2ff;
    color: #4f46e5;
}

.dep-kpi-icon.completed {
    background: #ecfdf5;
    color: #059669;
}

.dep-kpi-icon.urgent {
    background: #fef2f2;
    color: #dc2626;
}

.dep-kpi-details {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.dep-kpi-val {
    font-family: var(--font-heading, inherit);
    font-size: 19px;
    font-weight: 800;
    color: #0f172a;
    line-height: 1.1;
}

.dep-kpi-label {
    font-size: 11.5px;
    font-weight: 600;
    color: #64748b;
    margin-top: 2px;
}

/* ── Main Dependencies Table & Filter Card ─────────────────────────────── */
.dep-main-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
    overflow: hidden;
}

.dep-card-header {
    padding: 12px 18px;
    background: #ffffff;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.dep-header-title {
    font-size: 13.5px;
    font-weight: 700;
    color: #0f172a;
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
}

.dep-count-chip {
    font-size: 11px;
    font-weight: 700;
    background: #eef2ff;
    color: #4f46e5;
    padding: 2px 7px;
    border-radius: 9999px;
}

.dep-header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.dep-search-wrap {
    position: relative;
    width: 200px;
}

.dep-search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 12px;
    pointer-events: none;
}

.dep-search-input {
    width: 100%;
    height: 32px;
    padding: 4px 10px 4px 30px;
    font-size: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #f8fafc;
    color: #0f172a;
    outline: none;
    transition: all 0.2s ease;
}

.dep-search-input:focus {
    background: #ffffff;
    border-color: #4f46e5;
    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.15);
}

.dep-filter-select {
    height: 32px;
    padding: 0 8px;
    font-size: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #f8fafc;
    color: #334155;
    outline: none;
    cursor: pointer;
}

.dep-filter-select:focus {
    border-color: #4f46e5;
}

.btn-dep-reset {
    height: 32px;
    padding: 0 10px;
    font-size: 11.5px;
    font-weight: 600;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    color: #64748b;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.btn-dep-reset:hover {
    background: #f1f5f9;
    color: #0f172a;
}

/* ── Table Styling ─────────────────────────────────────────────────────── */
.dep-table-wrap {
    overflow-x: auto;
}

.dep-client-table {
    width: 100%;
    margin-bottom: 0;
    border-collapse: separate;
    border-spacing: 0;
}

.dep-client-table thead th {
    background: #f8fafc;
    color: #475569;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 10px 16px;
    border-bottom: 1px solid #e2e8f0;
    white-space: nowrap;
    text-align: left !important;
}

.dep-client-table tbody td {
    padding: 14px 16px;
    vertical-align: middle;
    border-bottom: 1px solid #f1f5f9;
    font-size: 12.5px;
    text-align: left !important;
}

.dep-client-table tbody tr:hover {
    background-color: #f8fafc;
}

.dep-client-table tbody tr.row-urgent {
    background-color: #fffbfb;
}

/* Table Elements */
.cell-dep-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
    text-align: left !important;
    gap: 3px;
    max-width: 300px;
}

.client-dep-code {
    font-family: monospace;
    font-size: 10.5px;
    font-weight: 700;
    color: #475569;
    background: #f1f5f9;
    padding: 2px 6px;
    border-radius: 4px;
    width: fit-content;
}

.client-dep-title-text {
    font-weight: 700;
    color: #0f172a;
    line-height: 1.35;
}

.client-dep-desc-text {
    font-size: 11.5px;
    color: #64748b;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.4;
}

.client-project-pill {
    font-size: 11.5px;
    font-weight: 600;
    color: #4f46e5;
    background: #eef2ff;
    padding: 3px 8px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    width: fit-content;
}

/* Priority & Status Badges */
.client-badge-priority {
    font-size: 10.5px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 20px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.client-badge-priority.urgent {
    background: #fee2e2;
    color: #b91c1c;
}

.client-badge-priority.high {
    background: #ffedd5;
    color: #c2410c;
}

.client-badge-priority.medium {
    background: #fef3c7;
    color: #b45309;
}

.client-badge-priority.low {
    background: #f1f5f9;
    color: #475569;
}

.client-badge-status {
    font-size: 11px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 20px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.client-badge-status.pending {
    background: #fffbeb;
    color: #b45309;
}

.client-badge-status.submitted {
    background: #eef2ff;
    color: #4338ca;
}

.client-badge-status.in_review {
    background: #f3e8ff;
    color: #6d28d9;
}

.client-badge-status.completed {
    background: #ecfdf5;
    color: #047857;
}

.client-badge-status.rejected {
    background: #fef2f2;
    color: #b91c1c;
}

/* Fields tags */
.client-fields-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    max-width: 220px;
}

.client-field-chip {
    font-size: 10.5px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 1px 5px;
    color: #475569;
    display: inline-flex;
    align-items: center;
    gap: 3px;
}

.client-field-chip.is-filled {
    border-color: #a7f3d0;
    background: #f0fdf4;
    color: #065f46;
}

/* Due Date */
.client-due-pill {
    font-size: 11px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.client-due-pill.overdue {
    background: #fef2f2;
    color: #dc2626;
}

.client-due-pill.urgent {
    background: #fff7ed;
    color: #ea580c;
}

.client-due-pill.normal {
    background: #eef2ff;
    color: #4f46e5;
}

/* Action Buttons */
.btn-client-fulfill {
    height: 30px;
    padding: 0 10px;
    background: #4f46e5;
    color: #ffffff;
    border: none;
    border-radius: 6px;
    font-size: 11.5px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.btn-client-fulfill:hover {
    background: #4338ca;
}

.btn-client-view {
    height: 30px;
    padding: 0 10px;
    background: #f8fafc;
    color: #334155;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 11.5px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.btn-client-view:hover {
    background: #f1f5f9;
    color: #0f172a;
}

/* ── Clean Compact Empty State ─────────────────────────────────────────── */
.dep-client-empty {
    padding: 42px 20px;
    text-align: center;
}

.dep-empty-icon-circle {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #eef2ff;
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin: 0 auto 10px auto;
}

.dep-client-empty h5 {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 4px;
}

.dep-client-empty p {
    font-size: 12px;
    color: #64748b;
    max-width: 400px;
    margin: 0 auto;
    line-height: 1.45;
}

/* ── Fulfill Modal ─────────────────────────────────────────────────────── */
.fulfill-modal {
    max-width: 580px !important;
    width: 95% !important;
    margin: 1.75rem auto;
}

.fulfill-modal .modal-content {
    border-radius: 16px;
    border: none;
    box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);
    overflow: hidden;
}

.fulfill-modal-header {
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    padding: 16px 20px 14px 20px;
}

.fulfill-header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
}

.fulfill-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
}

.fulfill-header-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: #eef2ff;
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
}

.fulfill-header-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.fulfill-header-code-row {
    display: flex;
    align-items: center;
    gap: 6px;
}

.fulfill-modal-title {
    font-size: 15.5px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.01em;
    margin: 0;
    line-height: 1.25;
}

.fulfill-modal-body {
    padding: 18px 20px;
    background: #f8fafc;
    max-height: calc(85vh - 130px);
    overflow-y: auto;
}

/* Modal Close Button */
.fulfill-modal-header .btn-modal-close-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    color: #64748b;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.fulfill-modal-header .btn-modal-close-icon:hover {
    background: #fee2e2;
    border-color: #fecaca;
    color: #dc2626;
    transform: rotate(90deg);
}

.priority-dot-mini {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    display: inline-block;
    background: currentColor;
    margin-right: 4px;
}

/* Meta Timeline & Security Banner */
.fulfill-meta-banner {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 16px;
}

.fulfill-meta-item {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.meta-icon-box {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: #eef2ff;
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    flex-shrink: 0;
}

.meta-icon-box.security {
    background: #ecfdf5;
    color: #059669;
}

.meta-content {
    display: flex;
    flex-direction: column;
}

.meta-label {
    font-size: 10.5px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #64748b;
}

.meta-val {
    font-size: 12.5px;
    color: #1e293b;
    font-weight: 500;
}

.meta-due-date {
    color: #64748b;
    font-size: 11.5px;
}

/* PM Instructions Box */
.modal-instructions-box {
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 10px;
    padding: 12px 16px;
    margin-bottom: 16px;
}

.instructions-header {
    font-size: 11.5px;
    font-weight: 700;
    color: #166534;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
}

.instructions-text {
    font-size: 12.5px;
    color: #14532d;
    line-height: 1.45;
    margin: 0;
}

/* Revision Box */
.modal-revision-box {
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 10px;
    padding: 12px 16px;
    margin-bottom: 16px;
}

.revision-header {
    font-size: 11.5px;
    font-weight: 700;
    color: #991b1b;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
}

.revision-text {
    font-size: 12.5px;
    color: #7f1d1d;
    line-height: 1.45;
    margin: 0;
}

/* Fields section */
.fields-section-title {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #475569;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
}

.dynamic-form-fields {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 16px;
}

.form-field-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 14px 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    transition: all 0.2s ease;
}

.form-field-card:focus-within {
    border-color: #4f46e5;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.08);
}

.field-type-pill {
    font-size: 10.5px;
    font-weight: 600;
    padding: 2px 7px;
    border-radius: 4px;
    background: #f1f5f9;
    color: #475569;
    display: inline-flex;
    align-items: center;
}

.field-type-pill.password {
    background: #fef3c7;
    color: #92400e;
}

.field-type-pill.file {
    background: #e0e7ff;
    color: #3730a3;
}

.field-type-pill.url {
    background: #e0f2fe;
    color: #0369a1;
}

/* Client Note Card */
.client-note-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 14px 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.client-note-label {
    font-size: 12.5px;
    font-weight: 600;
    color: #0f172a;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
}

.optional-tag {
    font-size: 11px;
    color: #64748b;
    font-weight: normal;
    margin-left: 4px;
}

/* Modal Footer */
.fulfill-modal-footer {
    background: #ffffff;
    border-top: 1px solid #e2e8f0;
    padding: 14px 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
}

.btn-modal-cancel {
    height: 38px;
    padding: 0 16px;
    border-radius: 8px;
    border: 1px solid #cbd5e1;
    background: #ffffff;
    color: #475569;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
}

.btn-modal-cancel:hover {
    background: #f1f5f9;
    color: #0f172a;
    border-color: #94a3b8;
}

.btn-modal-submit {
    height: 38px;
    padding: 0 20px;
    border-radius: 8px;
    border: none;
    background: #4f46e5;
    color: #ffffff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.25);
    transition: all 0.2s ease;
}

.btn-modal-submit:hover:not(:disabled) {
    background: #4338ca;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.35);
}

.btn-modal-submit:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.password-input-wrap {
    position: relative;
    display: flex;
    align-items: center;
}

.password-input-wrap input,
.dep-text-input {
    width: 100%;
    height: 36px;
    padding: 0 10px;
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    font-size: 12.5px;
    outline: none;
}

.password-input-wrap input {
    padding-right: 36px;
}

.password-input-wrap input:focus,
.dep-text-input:focus,
.dep-textarea:focus {
    border-color: #4f46e5;
}

.btn-toggle-pass {
    position: absolute;
    right: 8px;
    background: none;
    border: none;
    color: #64748b;
    cursor: pointer;
    padding: 4px;
    font-size: 14px;
}

.dep-textarea {
    width: 100%;
    padding: 8px 10px;
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    font-size: 12.5px;
    outline: none;
    resize: vertical;
}

.field-file-dropzone {
    border: 1.5px dashed #cbd5e1;
    border-radius: 8px;
    padding: 14px 10px;
    text-align: center;
    background: #f8fafc;
    cursor: pointer;
}

.field-file-dropzone:hover {
    border-color: #4f46e5;
    background: #eef2ff;
}

.file-dropzone-icon {
    font-size: 20px;
    color: #4f46e5;
    margin-bottom: 2px;
}

.file-dropzone-text {
    font-size: 12px;
    font-weight: 600;
    color: #334155;
    margin: 0;
}

.file-dropzone-sub {
    font-size: 10.5px;
    color: #94a3b8;
}

.selected-file-pill {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ecfdf5;
    border: 1px solid #a7f3d0;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 12px;
    color: #065f46;
}

.btn-remove-selected-file {
    background: none;
    border: none;
    color: #dc2626;
    cursor: pointer;
    font-size: 14px;
}

.field-help-text {
    font-size: 11px;
    color: #64748b;
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.client-note-group label {
    font-size: 12px;
    font-weight: 600;
    color: #0f172a;
    margin-bottom: 4px;
    display: block;
}

/* Toast */
.client-dep-toast {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 9999;
    padding: 10px 16px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
}

.client-dep-toast.success {
    background: #059669;
    color: #ffffff;
}

.client-dep-toast.error {
    background: #dc2626;
    color: #ffffff;
}

.client-dep-toast.info {
    background: #4f46e5;
    color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dependencies.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E,6EAA6E;AAC7E;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,iBAAiB;AACrB;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yCAAyC;IACzC,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA,6EAA6E;AAC7E;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,2BAA2B;IAC3B,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA,6EAA6E;AAC7E;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,oDAAoD;IACpD,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,wBAAwB;AACxB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":["/* ==========================================================================\n   CLIENT PORTAL - PROJECT DEPENDENCIES & DYNAMIC CREDENTIALS STYLES\n   Matches Dashboard.css and Support.css precision SaaS theme\n   ========================================================================== */\n\n/* ── Hero Bar ──────────────────────────────────────────────────────────── */\n.dep-hero-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 16px;\n    flex-wrap: wrap;\n}\n\n.dep-hero-left {\n    flex: 1;\n    min-width: 260px;\n}\n\n.dep-hero-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 3px 10px;\n    background: #eef2ff;\n    color: #4f46e5;\n    border: 1px solid #c7d2fe;\n    border-radius: 9999px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 6px;\n}\n\n.dep-hero-badge .pulse-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #4f46e5;\n    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.25);\n}\n\n.dep-hero-title {\n    font-family: var(--font-heading, inherit);\n    font-size: 22px;\n    font-weight: 800;\n    color: #0f172a;\n    margin: 0 0 4px 0;\n    letter-spacing: -0.4px;\n}\n\n.dep-hero-subtitle {\n    font-size: 12.5px;\n    color: #64748b;\n    margin: 0;\n    line-height: 1.45;\n}\n\n/* ── Executive KPI Cards Grid ──────────────────────────────────────────── */\n.dep-kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n@media (max-width: 992px) {\n    .dep-kpi-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 576px) {\n    .dep-kpi-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.dep-kpi-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 12px 16px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.dep-kpi-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n    border-color: #cbd5e1;\n}\n\n.dep-kpi-card.active {\n    border-color: #4f46e5;\n    background: #f8faff;\n    box-shadow: 0 2px 8px rgba(79, 70, 229, 0.12);\n}\n\n.dep-kpi-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 17px;\n    flex-shrink: 0;\n}\n\n.dep-kpi-icon.pending {\n    background: #fffbeb;\n    color: #d97706;\n}\n\n.dep-kpi-icon.review {\n    background: #eef2ff;\n    color: #4f46e5;\n}\n\n.dep-kpi-icon.completed {\n    background: #ecfdf5;\n    color: #059669;\n}\n\n.dep-kpi-icon.urgent {\n    background: #fef2f2;\n    color: #dc2626;\n}\n\n.dep-kpi-details {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.dep-kpi-val {\n    font-family: var(--font-heading, inherit);\n    font-size: 19px;\n    font-weight: 800;\n    color: #0f172a;\n    line-height: 1.1;\n}\n\n.dep-kpi-label {\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #64748b;\n    margin-top: 2px;\n}\n\n/* ── Main Dependencies Table & Filter Card ─────────────────────────────── */\n.dep-main-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);\n    overflow: hidden;\n}\n\n.dep-card-header {\n    padding: 12px 18px;\n    background: #ffffff;\n    border-bottom: 1px solid #f1f5f9;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.dep-header-title {\n    font-size: 13.5px;\n    font-weight: 700;\n    color: #0f172a;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0;\n}\n\n.dep-count-chip {\n    font-size: 11px;\n    font-weight: 700;\n    background: #eef2ff;\n    color: #4f46e5;\n    padding: 2px 7px;\n    border-radius: 9999px;\n}\n\n.dep-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.dep-search-wrap {\n    position: relative;\n    width: 200px;\n}\n\n.dep-search-icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #94a3b8;\n    font-size: 12px;\n    pointer-events: none;\n}\n\n.dep-search-input {\n    width: 100%;\n    height: 32px;\n    padding: 4px 10px 4px 30px;\n    font-size: 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: #f8fafc;\n    color: #0f172a;\n    outline: none;\n    transition: all 0.2s ease;\n}\n\n.dep-search-input:focus {\n    background: #ffffff;\n    border-color: #4f46e5;\n    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.15);\n}\n\n.dep-filter-select {\n    height: 32px;\n    padding: 0 8px;\n    font-size: 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: #f8fafc;\n    color: #334155;\n    outline: none;\n    cursor: pointer;\n}\n\n.dep-filter-select:focus {\n    border-color: #4f46e5;\n}\n\n.btn-dep-reset {\n    height: 32px;\n    padding: 0 10px;\n    font-size: 11.5px;\n    font-weight: 600;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    color: #64748b;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.btn-dep-reset:hover {\n    background: #f1f5f9;\n    color: #0f172a;\n}\n\n/* ── Table Styling ─────────────────────────────────────────────────────── */\n.dep-table-wrap {\n    overflow-x: auto;\n}\n\n.dep-client-table {\n    width: 100%;\n    margin-bottom: 0;\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n.dep-client-table thead th {\n    background: #f8fafc;\n    color: #475569;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    padding: 10px 16px;\n    border-bottom: 1px solid #e2e8f0;\n    white-space: nowrap;\n    text-align: left !important;\n}\n\n.dep-client-table tbody td {\n    padding: 14px 16px;\n    vertical-align: middle;\n    border-bottom: 1px solid #f1f5f9;\n    font-size: 12.5px;\n    text-align: left !important;\n}\n\n.dep-client-table tbody tr:hover {\n    background-color: #f8fafc;\n}\n\n.dep-client-table tbody tr.row-urgent {\n    background-color: #fffbfb;\n}\n\n/* Table Elements */\n.cell-dep-title {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start !important;\n    text-align: left !important;\n    gap: 3px;\n    max-width: 300px;\n}\n\n.client-dep-code {\n    font-family: monospace;\n    font-size: 10.5px;\n    font-weight: 700;\n    color: #475569;\n    background: #f1f5f9;\n    padding: 2px 6px;\n    border-radius: 4px;\n    width: fit-content;\n}\n\n.client-dep-title-text {\n    font-weight: 700;\n    color: #0f172a;\n    line-height: 1.35;\n}\n\n.client-dep-desc-text {\n    font-size: 11.5px;\n    color: #64748b;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    line-height: 1.4;\n}\n\n.client-project-pill {\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #4f46e5;\n    background: #eef2ff;\n    padding: 3px 8px;\n    border-radius: 6px;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    width: fit-content;\n}\n\n/* Priority & Status Badges */\n.client-badge-priority {\n    font-size: 10.5px;\n    font-weight: 700;\n    padding: 2px 7px;\n    border-radius: 20px;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n\n.client-badge-priority.urgent {\n    background: #fee2e2;\n    color: #b91c1c;\n}\n\n.client-badge-priority.high {\n    background: #ffedd5;\n    color: #c2410c;\n}\n\n.client-badge-priority.medium {\n    background: #fef3c7;\n    color: #b45309;\n}\n\n.client-badge-priority.low {\n    background: #f1f5f9;\n    color: #475569;\n}\n\n.client-badge-status {\n    font-size: 11px;\n    font-weight: 600;\n    padding: 3px 8px;\n    border-radius: 20px;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.client-badge-status.pending {\n    background: #fffbeb;\n    color: #b45309;\n}\n\n.client-badge-status.submitted {\n    background: #eef2ff;\n    color: #4338ca;\n}\n\n.client-badge-status.in_review {\n    background: #f3e8ff;\n    color: #6d28d9;\n}\n\n.client-badge-status.completed {\n    background: #ecfdf5;\n    color: #047857;\n}\n\n.client-badge-status.rejected {\n    background: #fef2f2;\n    color: #b91c1c;\n}\n\n/* Fields tags */\n.client-fields-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    max-width: 220px;\n}\n\n.client-field-chip {\n    font-size: 10.5px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 4px;\n    padding: 1px 5px;\n    color: #475569;\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n}\n\n.client-field-chip.is-filled {\n    border-color: #a7f3d0;\n    background: #f0fdf4;\n    color: #065f46;\n}\n\n/* Due Date */\n.client-due-pill {\n    font-size: 11px;\n    font-weight: 600;\n    padding: 2px 6px;\n    border-radius: 4px;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.client-due-pill.overdue {\n    background: #fef2f2;\n    color: #dc2626;\n}\n\n.client-due-pill.urgent {\n    background: #fff7ed;\n    color: #ea580c;\n}\n\n.client-due-pill.normal {\n    background: #eef2ff;\n    color: #4f46e5;\n}\n\n/* Action Buttons */\n.btn-client-fulfill {\n    height: 30px;\n    padding: 0 10px;\n    background: #4f46e5;\n    color: #ffffff;\n    border: none;\n    border-radius: 6px;\n    font-size: 11.5px;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.btn-client-fulfill:hover {\n    background: #4338ca;\n}\n\n.btn-client-view {\n    height: 30px;\n    padding: 0 10px;\n    background: #f8fafc;\n    color: #334155;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 11.5px;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.btn-client-view:hover {\n    background: #f1f5f9;\n    color: #0f172a;\n}\n\n/* ── Clean Compact Empty State ─────────────────────────────────────────── */\n.dep-client-empty {\n    padding: 42px 20px;\n    text-align: center;\n}\n\n.dep-empty-icon-circle {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: #eef2ff;\n    color: #4f46e5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    margin: 0 auto 10px auto;\n}\n\n.dep-client-empty h5 {\n    font-size: 14px;\n    font-weight: 700;\n    color: #0f172a;\n    margin-bottom: 4px;\n}\n\n.dep-client-empty p {\n    font-size: 12px;\n    color: #64748b;\n    max-width: 400px;\n    margin: 0 auto;\n    line-height: 1.45;\n}\n\n/* ── Fulfill Modal ─────────────────────────────────────────────────────── */\n.fulfill-modal {\n    max-width: 580px !important;\n    width: 95% !important;\n    margin: 1.75rem auto;\n}\n\n.fulfill-modal .modal-content {\n    border-radius: 16px;\n    border: none;\n    box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);\n    overflow: hidden;\n}\n\n.fulfill-modal-header {\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    padding: 16px 20px 14px 20px;\n}\n\n.fulfill-header-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    width: 100%;\n}\n\n.fulfill-header-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n}\n\n.fulfill-header-icon {\n    width: 38px;\n    height: 38px;\n    border-radius: 10px;\n    background: #eef2ff;\n    color: #4f46e5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    flex-shrink: 0;\n}\n\n.fulfill-header-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.fulfill-header-code-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.fulfill-modal-title {\n    font-size: 15.5px;\n    font-weight: 700;\n    color: #0f172a;\n    letter-spacing: -0.01em;\n    margin: 0;\n    line-height: 1.25;\n}\n\n.fulfill-modal-body {\n    padding: 18px 20px;\n    background: #f8fafc;\n    max-height: calc(85vh - 130px);\n    overflow-y: auto;\n}\n\n/* Modal Close Button */\n.fulfill-modal-header .btn-modal-close-icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: 1px solid #e2e8f0;\n    background: #f8fafc;\n    color: #64748b;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n}\n\n.fulfill-modal-header .btn-modal-close-icon:hover {\n    background: #fee2e2;\n    border-color: #fecaca;\n    color: #dc2626;\n    transform: rotate(90deg);\n}\n\n.priority-dot-mini {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    display: inline-block;\n    background: currentColor;\n    margin-right: 4px;\n}\n\n/* Meta Timeline & Security Banner */\n.fulfill-meta-banner {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.fulfill-meta-item {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 10px 14px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.meta-icon-box {\n    width: 34px;\n    height: 34px;\n    border-radius: 8px;\n    background: #eef2ff;\n    color: #4f46e5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    flex-shrink: 0;\n}\n\n.meta-icon-box.security {\n    background: #ecfdf5;\n    color: #059669;\n}\n\n.meta-content {\n    display: flex;\n    flex-direction: column;\n}\n\n.meta-label {\n    font-size: 10.5px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #64748b;\n}\n\n.meta-val {\n    font-size: 12.5px;\n    color: #1e293b;\n    font-weight: 500;\n}\n\n.meta-due-date {\n    color: #64748b;\n    font-size: 11.5px;\n}\n\n/* PM Instructions Box */\n.modal-instructions-box {\n    background: #f0fdf4;\n    border: 1px solid #bbf7d0;\n    border-radius: 10px;\n    padding: 12px 16px;\n    margin-bottom: 16px;\n}\n\n.instructions-header {\n    font-size: 11.5px;\n    font-weight: 700;\n    color: #166534;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    margin-bottom: 4px;\n    display: flex;\n    align-items: center;\n}\n\n.instructions-text {\n    font-size: 12.5px;\n    color: #14532d;\n    line-height: 1.45;\n    margin: 0;\n}\n\n/* Revision Box */\n.modal-revision-box {\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    border-radius: 10px;\n    padding: 12px 16px;\n    margin-bottom: 16px;\n}\n\n.revision-header {\n    font-size: 11.5px;\n    font-weight: 700;\n    color: #991b1b;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    margin-bottom: 4px;\n    display: flex;\n    align-items: center;\n}\n\n.revision-text {\n    font-size: 12.5px;\n    color: #7f1d1d;\n    line-height: 1.45;\n    margin: 0;\n}\n\n/* Fields section */\n.fields-section-title {\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #475569;\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n}\n\n.dynamic-form-fields {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.form-field-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 14px 16px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);\n    transition: all 0.2s ease;\n}\n\n.form-field-card:focus-within {\n    border-color: #4f46e5;\n    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.08);\n}\n\n.field-type-pill {\n    font-size: 10.5px;\n    font-weight: 600;\n    padding: 2px 7px;\n    border-radius: 4px;\n    background: #f1f5f9;\n    color: #475569;\n    display: inline-flex;\n    align-items: center;\n}\n\n.field-type-pill.password {\n    background: #fef3c7;\n    color: #92400e;\n}\n\n.field-type-pill.file {\n    background: #e0e7ff;\n    color: #3730a3;\n}\n\n.field-type-pill.url {\n    background: #e0f2fe;\n    color: #0369a1;\n}\n\n/* Client Note Card */\n.client-note-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 14px 16px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);\n}\n\n.client-note-label {\n    font-size: 12.5px;\n    font-weight: 600;\n    color: #0f172a;\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n}\n\n.optional-tag {\n    font-size: 11px;\n    color: #64748b;\n    font-weight: normal;\n    margin-left: 4px;\n}\n\n/* Modal Footer */\n.fulfill-modal-footer {\n    background: #ffffff;\n    border-top: 1px solid #e2e8f0;\n    padding: 14px 24px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n.btn-modal-cancel {\n    height: 38px;\n    padding: 0 16px;\n    border-radius: 8px;\n    border: 1px solid #cbd5e1;\n    background: #ffffff;\n    color: #475569;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.btn-modal-cancel:hover {\n    background: #f1f5f9;\n    color: #0f172a;\n    border-color: #94a3b8;\n}\n\n.btn-modal-submit {\n    height: 38px;\n    padding: 0 20px;\n    border-radius: 8px;\n    border: none;\n    background: #4f46e5;\n    color: #ffffff;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.25);\n    transition: all 0.2s ease;\n}\n\n.btn-modal-submit:hover:not(:disabled) {\n    background: #4338ca;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.35);\n}\n\n.btn-modal-submit:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.password-input-wrap {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.password-input-wrap input,\n.dep-text-input {\n    width: 100%;\n    height: 36px;\n    padding: 0 10px;\n    border-radius: 6px;\n    border: 1px solid #cbd5e1;\n    font-size: 12.5px;\n    outline: none;\n}\n\n.password-input-wrap input {\n    padding-right: 36px;\n}\n\n.password-input-wrap input:focus,\n.dep-text-input:focus,\n.dep-textarea:focus {\n    border-color: #4f46e5;\n}\n\n.btn-toggle-pass {\n    position: absolute;\n    right: 8px;\n    background: none;\n    border: none;\n    color: #64748b;\n    cursor: pointer;\n    padding: 4px;\n    font-size: 14px;\n}\n\n.dep-textarea {\n    width: 100%;\n    padding: 8px 10px;\n    border-radius: 6px;\n    border: 1px solid #cbd5e1;\n    font-size: 12.5px;\n    outline: none;\n    resize: vertical;\n}\n\n.field-file-dropzone {\n    border: 1.5px dashed #cbd5e1;\n    border-radius: 8px;\n    padding: 14px 10px;\n    text-align: center;\n    background: #f8fafc;\n    cursor: pointer;\n}\n\n.field-file-dropzone:hover {\n    border-color: #4f46e5;\n    background: #eef2ff;\n}\n\n.file-dropzone-icon {\n    font-size: 20px;\n    color: #4f46e5;\n    margin-bottom: 2px;\n}\n\n.file-dropzone-text {\n    font-size: 12px;\n    font-weight: 600;\n    color: #334155;\n    margin: 0;\n}\n\n.file-dropzone-sub {\n    font-size: 10.5px;\n    color: #94a3b8;\n}\n\n.selected-file-pill {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #ecfdf5;\n    border: 1px solid #a7f3d0;\n    border-radius: 6px;\n    padding: 6px 10px;\n    font-size: 12px;\n    color: #065f46;\n}\n\n.btn-remove-selected-file {\n    background: none;\n    border: none;\n    color: #dc2626;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.field-help-text {\n    font-size: 11px;\n    color: #64748b;\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.client-note-group label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #0f172a;\n    margin-bottom: 4px;\n    display: block;\n}\n\n/* Toast */\n.client-dep-toast {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    z-index: 9999;\n    padding: 10px 16px;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);\n}\n\n.client-dep-toast.success {\n    background: #059669;\n    color: #ffffff;\n}\n\n.client-dep-toast.error {\n    background: #dc2626;\n    color: #ffffff;\n}\n\n.client-dep-toast.info {\n    background: #4f46e5;\n    color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
